/* eslint-disable react/no-unused-state */
/* eslint-disable no-shadow */
import { hideLoader } from "action/loader/hideLoader";
import { showLoader } from "action/loader/showLoader";
import { closeModal } from "action/modal/closeModal";
import { openModal } from "action/modal/openModal";
import classnames from "classnames";
import ResponsiveContext from "component/design-system/react-responsive/Context";
import LocationContext from "hooks-contexts/LocationContext";
import { ProductContextProvider } from "hooks-contexts/ProductContext";
import { RootState } from "interfaces/generics.type";
import checkoutContainerStyles from "modules/checkout/common/checkoutContainer.module.scss";
import { ToastProvider } from "modules/components/toast/ToastContext";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { Component } from "react";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import canUseWebpImage from "util/helper/can-use-webp";
import { refresh } from "../action/auth/refresh";
import { refreshShoppingCart } from "../action/shopping-cart/refreshShoppingCart";
import WebpContext from "../hooks-contexts/WebpContext";
import HeaderModalLoader from "../modules/modals/HeaderModalLoader";
import { logPageView } from "../util/activitywatcher";
import { checkExactRouteMatch } from "../util/url/checkExactRouteMatch";
import {
  isCheckoutFlowPages, isCheckoutPages, isLoginPage, isShoppingCartPage,
} from "../util/url/checkRouteInclude";
import withWindowResizeListener from "../util/withWindowResizeListener";
import RootLayoutMount from "./RootLayoutMount";

const CheckoutHeader = dynamic(() => import(/* webpackChunkName: "header-checkout" */ "../modules/checkout/checkout-header"));
const LoginHeader = dynamic(() => import(/* webpackChunkName: "header-login" */ "../modules/login/LoginHeader"));
const Header = dynamic(() => import(/* webpackChunkName: "header" */ "./header/header.container"));
const FooterLogin = dynamic(() => import(/* webpackChunkName: "footer-login" */ "./footer/footer-login/FooterLogin"));
const Footer = dynamic(() => import(/* webpackChunkName: "footer" */ "./footer/Footer"));
const FooterCheckoutShoppingCart = dynamic(() => import(/* webpackChunkName: "footer-checkout-shopping-cart" */ "./footer/footer-checkout-shopping-cart/FooterCheckoutShoppingCart"));

class App extends Component {
  urlHistory: any;

  userSessionReqId: any;

  setCanUseWebp = (canUseWebp: boolean) => {
    this.setState({ canUseWebp });
  };

  constructor(props: any) {
    super(props);
    this.state = {
      canUseWebp: true,
      setCanUseWebp: this.setCanUseWebp,
    };
    this.urlHistory = [];
    this.handleRouteChange = this.handleRouteChange.bind(this);
    this.googleLoginLoad = this.googleLoginLoad.bind(this);
  }

  googleLoginLoad() {
    // yieldToMain().then(() => {
    //   const {
    //     refreshSession, showLoader, hideLoader, closeModal,
    //     authLoggedIn,
    //   } = this.props;
    //   if (!window.onGoogleLibraryLoad) {
    //     import("component/login/LoginUtil")
    //       .then((module) => {
    //         module.googleLoginScriptHandler(true, authLoggedIn, {
    //           refreshSession, showLoader, hideLoader, closeModal,
    //         });
    //       });
    //   }
    // });
  }

  handleRouteChange(url: any) {
    const { asPath, pathname } = this.props.router;
    const { urlHistory } = this;
    if (urlHistory.length > 5) {
      this.urlHistory = [...urlHistory.slice(1), asPath];
    } else {
      this.urlHistory = [...urlHistory, asPath];
    }
    logPageView(
      url,
      urlHistory.length > 0 ? urlHistory[urlHistory.length - 1] : undefined,
      false,
    );

    // We certify that modals are closed when routing
    if (pathname !== "/search") {
      if (this.props.selectedModelId) {
        // this.props.closeModal();
      }
    }
  }

  componentDidMount() {
    this.props.router.events.on("routeChangeStart", this.handleRouteChange);
    this.props.router.events.on("routeChangeComplete", this.googleLoginLoad);
    this.setState({ canUseWebp: canUseWebpImage() });

    // set first route
    this.urlHistory = [window.location.href];
    // delay Chat initialization for to reduce intial load
    // if (process.env.NEXT_PUBLIC_VAR_ENV === "production" && process.browser) {
    // }
  }

  componentWillUnmount() {
    this.props.router.events.off("routeChangeStart", this.handleRouteChange);
    this.props.router.events.off("routeChangeComplete", this.googleLoginLoad);
    if (this.userSessionReqId) {
      clearTimeout(this.userSessionReqId);
    }
  }

  componentDidUpdate(prevProps: any) {
    // const { isLoading } = this.props.garage;
    // // Initial vehicle selected
    // if (prevProps.garage.isLoading !== isLoading && !isLoading) {
    //   AmpService.initialVehicle(this.props.garage);
    // }

    if (this.props.authRefreshStatus === "complete") {
      if (prevProps.authLoggedIn !== this.props.authLoggedIn) {
        window.isUserSignedIn = this.props.authLoggedIn;
      }
    }
  }

  render() {
    const { width, router, isUnsecure } = this.props;
    const isCheckoutPage = isCheckoutPages(router.pathname, router.query);
    const isCheckoutFooter = (isShoppingCartPage(router.pathname) || isCheckoutFlowPages(router.pathname, router.query));

    let displayHeader;
    if (isLoginPage(router.pathname)) {
      displayHeader = (
        <header className="hidden-print" style={{ backgroundColor: isLoginPage(router.pathname) ? "#fff" : "#1a4d7c" }}>
          <LoginHeader />
        </header>
      );
    } else if (isCheckoutPages(router.pathname, router.query) || (isShoppingCartPage(router.pathname) && this.props.businessCustomer)) {
      displayHeader = (
        <header className="hidden-print" style={{ backgroundColor: isLoginPage(router.pathname) ? "#fff" : "#1a4d7c" }}>
          <CheckoutHeader />
        </header>
      );
    } else {
      displayHeader = <Header />;
    }
    return (
      <LocationContext.Provider value={{ location: this.props.location }}>
        <ResponsiveContext.Provider value={{ width }}>
          <WebpContext.Provider value={this.state}>
            <ProductContextProvider>
              <ToastProvider>
                <div className={classnames({ [checkoutContainerStyles.checkout_layout]: isCheckoutPage })}>
                  {displayHeader}

                  <HeaderModalLoader />

                  <RootLayoutMount isUnsecure={isUnsecure} />

                  <main>
                    <div id="google_translate_element"> </div>
                    {this.props.children}
                  </main>

                  <HideIf show={!this.props.businessCustomer && !checkExactRouteMatch(router, ["support"])}>
                    <footer style={isCheckoutFooter ? { zIndex: "-1", position: "relative" } : {}}>
                      <HideIf show={isLoginPage(router.pathname)}>
                        <FooterLogin />
                      </HideIf>
                      <HideIf show={!checkExactRouteMatch(router, ["shopping-cart", "checkout", "login"])}>
                        <Footer />
                      </HideIf>
                      <HideIf show={checkExactRouteMatch(router, ["shopping-cart", "checkout"])}>
                        <FooterCheckoutShoppingCart extraPadding={isCheckoutFooter} />
                      </HideIf>
                    </footer>
                  </HideIf>
                  {/* <AnchorTop /> */}
                </div>
              </ToastProvider>
            </ProductContextProvider>
          </WebpContext.Provider>
        </ResponsiveContext.Provider>
      </LocationContext.Provider>
    );
  }
}

function AppWithRouter(props: any) {
  const utils = useSelector((state: RootState) => state.utils);
  const modal = useSelector((state: RootState) => state.modal);
  const auth = useSelector((state: RootState) => state.authenticationState);
  const garage = useSelector((state: RootState) => state.garage);

  const dispatch = useDispatch();
  const router = useRouter();

  return (
    <App
      {...props}
      width={utils.width}
      selectedModelId={modal.selectedId}
      authLoggedIn={auth.loggedIn}
      authRefreshStatus={auth.refreshStatus}
      businessCustomer={auth.businessCustomer}
      garage={garage}
      refreshSession={(callback: any) => dispatch(refresh(callback))}
      showLoader={() => dispatch(showLoader())}
      hideLoader={() => dispatch(hideLoader())}
      openModal={(id: string) => dispatch(openModal(id))}
      closeModal={() => dispatch(closeModal())}
      refreshShoppingCart={() => dispatch(refreshShoppingCart())}
      router={router}
    />
  );
}

export default withWindowResizeListener(AppWithRouter);
